module.exports = __webpack_public_path__ + "static/media/dashvideo.112fb05d.webm";